import styled from 'styled-components'
import colors from '../../../assets/colors'
import { tokens } from '../../../assets/tokens'

const LinearPercentWithTitleStyled = styled.div`
   &&>p{
        margin-bottom: 8px;
    }
    .title-name{
        margin-bottom: 2px;
    }
  @media print {
    .MuiLinearProgress-root {
      background: ${colors.greyAlpha25}!important;
      -webkit-print-color-adjust: exact;
    }

    .linear-percent {
      color: ${props => props.theme.primary}!important;
      -webkit-print-color-adjust: exact;
    }
  }
  .MuiLinearProgress-root {
    height: 4px;
    border-radius: 8px;
    background: ${tokens.color.border.subtle};
  }

  .linear-percent {
    font-weight: bold;
    font-size: 28px;
    line-height: 28px;
    margin-bottom: 0;
    margin-top: 10px;
    color: ${props => props.theme.primary};
    text-align: center;
    display: block;
  }

  .title-name{
    display: flex;
    flex-direction: row;
    text-align: center;
    justify-content: space-between;
  }

  /* Nombre 13/500 y porcentaje 13/600, como el resto de la ficha */
  p {
    font-weight: 500 !important;
    font-size: 13px !important;
    line-height: 18px !important;
    color: ${tokens.color.text.primary};
  }

  .value {
    font-weight: 600 !important;
  }
`

export default LinearPercentWithTitleStyled